<template>
  <div class="content-template">
    <v-card>
      <v-card-title>
        Template bài viết 2
        <v-spacer />
        <div class="d-flex align-center">
          <v-btn small outlined color="primary" class="mr-2" @click="getItems">
            <v-icon left small>mdi-refresh</v-icon>
            Làm mới
          </v-btn>

          <v-btn small color="teal darken-4" dark @click="openDialog">
            <v-icon left small>mdi-plus</v-icon>
            Thêm mới
          </v-btn>
        </div>
      </v-card-title>

      <v-card-text>
        <v-data-table
          :items="items"
          :headers="headers"
          :search="search"
          dense
          fixed-header
          height="500px"
        >
          <!-- Actions -->
          <template v-slot:[`item.actions`]="{ item }">
            <v-btn small text color="primary" @click="openDetail(item.id)">
              Chi tiết
            </v-btn>

            <v-btn small text color="red" @click="confirmDelete(item.id)">
              Xóa
            </v-btn>
          </template>

          <!-- CreatedAt -->
          <template v-slot:[`item.createdAt`]="{ item }">
            {{ formatDate(item.createdAt) }}
          </template>

          <!-- UpdatedAt -->
          <template v-slot:[`item.updatedAt`]="{ item }">
            {{ formatDate(item.updatedAt) }}
          </template>

          <!-- Avatar as image -->
          <template v-slot:[`item.avatar`]="{ item }">
            <v-img
              :src="item.avatar"
              max-width="300"
              max-height="300"
              contain
              class="mx-auto"
            />
          </template>

          <!-- Attachment as clickable icon -->
          <template v-slot:[`item.attachment`]="{ item }">
            <v-btn
              icon
              color="primary"
              :href="item.attachment"
              target="_blank"
              download
            >
              <v-icon>mdi-file</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <v-dialog v-model="dialog" max-width="1200" persistent>
      <create-form
        :id="selected"
        @close="closeDialog"
        @set-id="setId"
        @refresh="getItems"
      />
    </v-dialog>
  </div>
</template>

<script>
import ContentTemplateApi from './api'
import CreateForm from './Create'

const HEADERS = [
  { text: 'Thao tác', value: 'actions', width: 160 },
  { text: 'ID', value: 'id' },
  { text: 'Tên', value: 'name', width: 150 },
  { text: 'Nội dung', value: 'body', width: 250 },
  { text: 'Ảnh', value: 'avatar', width: 150 },
  { text: 'Tệp đính kèm', value: 'attachment', width: 150 },
  { text: 'Ngày tạo', value: 'createdAt', width: 150 },
  { text: 'Người tạo', value: 'createdBy', width: 120 },
  { text: 'Ngày cập nhật', value: 'updatedAt', width: 150 },
  { text: 'Người cập nhật', value: 'updatedBy', width: 120 },
]

export default {
  components: { CreateForm },
  data() {
    return {
      items: [],
      selected: -1,
      headers: HEADERS,
      search: "",
      dialog: false,
    }
  },
  methods: {
    async getItems() {
      try {
        this.items = await ContentTemplateApi.gets()
      } catch (err) {
        console.error("Failed to load items:", err)
      }
    },
    openDialog() {
      this.selected = -1
      this.dialog = true
    },
    closeDialog() {
      this.dialog = false
      this.selected = -1
    },
    openDetail(id) {
      this.selected = id
      this.dialog = true
    },
    setId(id) {
      this.selected = id
      console.log("Selected ID:", id)
    },
    formatDate(date) {
      if (!date) return ""
      const d = new Date(date)
      return d.toLocaleDateString("vi-VN", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric"
      })
    },
    confirmDelete(id) {
      if (confirm("Bạn có chắc chắn muốn xóa mục này không?")) {
        this.deleteItem(id)
      }
    },

    async deleteItem(id) {
      try {
        await ContentTemplateApi.delete(id) // Make sure API has a delete method
        this.items = this.items.filter(item => item.id !== id)
        this.$toast?.success("Xóa thành công") // optional toast
      } catch (err) {
        console.error("Failed to delete item:", err)
        this.$toast?.error("Xóa thất bại")
      }
    }
  },
  mounted() {
    this.getItems()
  }
}
</script>
